module.exports = "../../../../platform/assets/pageMainIcon/industry_yewuchulilei1.svg";